module.exports = __webpack_public_path__ + "static/media/hardening.ddc094f0.png";